/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unknown-property */
import React from 'react';
import s from './WeatherCities.scss';
import Link from '../../../components/Link/Link';
import Listingheader from '../../../routes/home/components/common/ListingheaderV2';

const WeatherCities = ({ items, name, pageType, ga4Type, ga4Category }) => (
  <div className={s.otherCitiesWrap}>
    {name && <Listingheader headingname={name} />}
    <ul className={s.btmLink}>
      {items &&
        Array.isArray(items) &&
        items.length > 0 &&
        items.map(
          item =>
            ((pageType &&
              (pageType === 'weather' || pageType === 'no_AQI') &&
              item.weather_url) ||
              (pageType && pageType !== 'weather' && item.aqi_url)) && (
              <li>
                <Link
                  to={
                    pageType &&
                    (pageType === 'weather' || pageType === 'no_AQI')
                      ? item.weather_url
                      : item.aqi_url
                  }
                  ga4Data={
                    ga4Type && ga4Type === 'weather_other_cities'
                      ? [
                          {
                            event: 'user_click',
                            type: `${item.aqi_city}_click`,
                            category: ga4Category,
                            label: 'weather_aqi_landing',
                          },
                        ]
                      : []
                  }
                >
                  {item.aqi_city}
                </Link>
              </li>
            ),
        )}
    </ul>
  </div>
);

export default WeatherCities;
